import React, {HTMLAttributes} from 'react';
import {theme, FontColor, FontSize, FontWeight} from './Common';

export type SpanProps = {
  fontSize?: FontSize;
  fontWeight?: FontWeight;
  fontColor?: FontColor;
} & HTMLAttributes<HTMLSpanElement>;

export function Span({
  fontColor = 'darkGray',
  fontSize = 'small',
  fontWeight = 'light',
  style,
  ...props
}: SpanProps) {
  return (
    <span
      style={{
        fontSize: theme.font.sizes[fontSize],
        color: theme.colors[fontColor],
        fontWeight: theme.font[fontWeight],
        fontFamily: theme.font.family,
        lineHeight: 1.5,
        ...style,
      }}
      {...props}
    />
  );
}
